// Scroll-triggered reveals via IntersectionObserver.
// Elements with .reveal class fade + slide in when they enter the viewport.
// The hidden state is armed HERE (html.reveal-ready), not at parse time:
// if this module never loads or IntersectionObserver is missing, content
// simply stays visible instead of leaving a blank page.

if (!('IntersectionObserver' in window)) {
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-revealed'));
  throw new Error('no IntersectionObserver: reveals disabled');
}
document.documentElement.classList.add('reveal-ready');

const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    }
  }
}, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });

const hydrate = () => {
  document.querySelectorAll('.reveal:not(.is-revealed)').forEach(el => observer.observe(el));
};

document.addEventListener('DOMContentLoaded', hydrate);
// Re-run after late-injected content
window.addEventListener('load', hydrate);
